export default __webpack_public_path__ + "static/media/3485.e882bca5.svg";